import {useState} from "react";
import {useTranslation} from "react-i18next";
import {FiPlayCircle, FiX} from "react-icons/fi";
import styles from "./QuestionVideo.module.css";

/**
 * Lazy Cloudflare Stream player for a question's video explanation.
 * Renders nothing when there is no playback URL. Shows a thumbnail/button that
 * expands into an embedded iframe player on click (so list pages don't load
 * many iframes at once).
 */
const QuestionVideo = ({playbackUrl, thumbnailUrl}) => {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);

    if (!playbackUrl) return null;

    return (
        <div className={styles.wrap}>
            {!open ? (
                <button type="button" className={styles.trigger} onClick={() => setOpen(true)}>
                    {thumbnailUrl ? (
                        <span className={styles.thumb} style={{backgroundImage: `url(${thumbnailUrl})`}}>
                            <span className={styles.playOverlay}><FiPlayCircle size={30}/></span>
                        </span>
                    ) : (
                        <FiPlayCircle size={18} className={styles.playIcon}/>
                    )}
                    <span className={styles.triggerLabel}>{t("pages.questionForm.videoWatch")}</span>
                </button>
            ) : (
                <div className={styles.playerBox}>
                    <div className={styles.playerHead}>
                        <span className={styles.playerTitle}>{t("pages.questionForm.videoSectionTitle")}</span>
                        <button
                            type="button"
                            className={styles.closeBtn}
                            onClick={() => setOpen(false)}
                            aria-label={t("common.close")}
                        >
                            <FiX size={16}/>
                        </button>
                    </div>
                    <div className={styles.iframeWrap}>
                        <iframe
                            src={playbackUrl}
                            title={t("pages.questionForm.videoSectionTitle")}
                            loading="lazy"
                            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                            allowFullScreen
                            className={styles.iframe}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default QuestionVideo;
